import {createSlice} from '@reduxjs/toolkit';
import {loadCalendarDays, setToday} from './actions';
import {calendarDaysAdapter, calendarWeeksAdapter} from './adapters';
import {initialState} from './initialState';

const slice = createSlice({
  name: 'calendar',
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(setToday, (state, {payload}) => {
        state.today = payload;
      })
      .addCase(loadCalendarDays.pending, (state) => {
        state.loadingStatus = 'Loading';
      })
      .addCase(loadCalendarDays.fulfilled, (state, {payload}) => {
        const {days, weeks} = payload;
        calendarDaysAdapter.setAll(state.days, days);
        calendarWeeksAdapter.setAll(state.weeks, weeks);
        state.loadingStatus = 'Loaded';
      })
      .addCase(loadCalendarDays.rejected, (state) => {
        state.loadingStatus = 'Failed';
      });
  },
});

export const {reducer: calendarReducer} = slice;
